import React, { useState, useEffect } from "react";

import moment from "moment";
import Popup from "reactjs-popup";
import { Link } from "react-router-dom";
import { useParams } from "react-router";
import "react-datepicker/dist/react-datepicker.css";

import { getOfferApplyList } from "services/offer_service";

import TopAdd from "components/TopAdd";
import Topnav from "components/Topnav";
import RightAdd from "components/RightAdd";

function App() {
  const [offerApplyList, setOfferApplyList] = useState([]);
  const { offerId } = useParams();

  useEffect(() => {
    async function fetchData() {
      if (!offerId) return;

      let offerList = await getOfferApplyList(offerId);
      setOfferApplyList(offerList);
    }

    fetchData();
  }, []);

  return (
    <div className="geral">
      <div className="App">
        <Topnav></Topnav>
        <div className="conteudo">
        <TopAdd></TopAdd>
        <div style={{"display": "flex"}}>
          <section className="section dashboard">
            <nav className="breadcrumb" aria-label="breadcrumbs">
              <ul>
                <Link to={"/ofertas"}>Vagas</Link> /{" "}
              </ul>
            </nav>
            <div className="geral">
              <div className="hero is-footsolution">
                <div className="columns">
                  <div className="column">
                    <h1 className="title is-3">Vagas</h1>
                  </div>
                </div>
              </div>
            </div>
            <div className="columns">
            <table className="table fullwidth">
                <thead>
                  <tr>
                    <th>
                      <abbr title="Position">Nome</abbr>
                    </th>
                    <th>
                      <abbr title="Played">Data da candidatura</abbr>
                    </th>
                    <th>
                      <abbr title="Played">Ações</abbr>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {offerApplyList.map((offerApplyList) => (
                    <tr>
                      <td>
                        <Link to={"/conta/"+offerApplyList.attributes?.account?.data?.id}>
                          {offerApplyList.attributes?.account?.data?.attributes?.name}
                        </Link>
                      </td>
                      <td>
                        {moment(offerApplyList.attributes.createdAt).format(
                          "DD/MM/YYYY HH:MM"
                        )}
                      </td>
                      <td>
                        <Popup
                          trigger={<i className="fa fa-ellipsis-v"></i>}
                          position="right center"
                        >
                          <div className="dropdown-content">
                            <Link
                              className="dropdown-item"
                              to={`/ofertas/${offerId}/candidaturas/${offerApplyList.id}`}
                            >
                              Detalhe da candidatura
                            </Link>
                          </div>
                        </Popup>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </section>
          <RightAdd></RightAdd>
         </div>
        </div>
      </div>
    </div>
  );
}

export default App;
